import React, { useState, ChangeEvent, FormEvent, useEffect } from "react";
import "../../App.css";
import {
  Box,
  Container,
  CssBaseline,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoginData } from "../../types/loginData";
import { login } from "../../api/authApi";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";

const styles = {
  input: {
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#303030",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 3,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#303030",
    },
  },
  button: {
    backgroundColor: "#303030",
    borderRadius: 2,
    fontWeight: "bold",
    letterSpacing: 1,
    height: 45,
    marginTop: 2,
    "&:hover": {
      backgroundColor: "#454545",
    },
    "&:focus": {
      backgroundColor: "#454545",
    },
  },
};

function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState<LoginData>({
    login_usuario: "",
    password: "",
    aplicacao: "Entrega",
  });

  const defaultTheme = createTheme({
    typography: {
      fontFamily: "Poppins, sans-serif",
    },
  });

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setLoginData({ ...loginData, [event.target.name]: event.target.value });
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const navigate = useNavigate();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await login(loginData);
      localStorage.setItem("token", response.token);
      localStorage.setItem("id_empresa", response.id_empresa);
      localStorage.setItem("canal", response.canal);
      localStorage.setItem("events", JSON.stringify(response.events)); 
      localStorage.setItem("userData", JSON.stringify(response));
      toast.success("Logado com sucesso!");

      setTimeout(() => {
        navigate("/dashboard");
      }, 800);
    } catch (error: unknown) {
      if (error instanceof Error) {
        toast.error(error.message);
      }
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1200);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dashboard");
    }
  });

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minHeight: "100vh",
            justifyContent: "center",
          }}
        >
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12} textAlign="center">
              <img
                src="../../logoStaff.png"
                alt="Staff 360"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography
                component="h1"
                variant="h5"
                fontWeight="bold"
                textAlign="center"
              >
                Bem-vindo(a) ao <br /> Entrega Impecável
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box component="form" noValidate onSubmit={handleSubmit}>
                <TextField
                  margin="normal"
                  fullWidth
                  id="login_usuario"
                  label="Usuário"
                  name="login_usuario"
                  autoComplete="email"
                  autoFocus
                  value={loginData.login_usuario}
                  onChange={handleInputChange}
                  sx={styles.input}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  name="password"
                  label="Senha"
                  type={showPassword ? "text" : "password"}
                  value={loginData.password}
                  onChange={handleInputChange}
                  sx={styles.input}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          aria-label="visualizar senha"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <LoadingButton
                  loading={loading}
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={styles.button}
                >
                  Entrar
                </LoadingButton>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export default LoginPage;
